import { render } from "./string-life-report-filter.vue?vue&type=template&id=38722c84&ts=true"
import script from "./string-life-report-filter.vue?vue&type=script&lang=ts"
export * from "./string-life-report-filter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__